import React, { useState, useEffect } from "react";
import { Progress, Typography, Modal, Button, Space } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const WarningModal = ({ open, timeRemainingMs, onContinue, onCloseX }) => {
  const [secondsLeft, setSecondsLeft] = useState(Math.floor(timeRemainingMs / 1000));

  useEffect(() => {
    setSecondsLeft(Math.floor(timeRemainingMs / 1000));
  }, [timeRemainingMs]);

  useEffect(() => {
    let interval;
    if (open) {
      interval = setInterval(() => {
        setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [open]);

  const totalWarningSeconds = 5 * 60;
  const percent = Math.max(0, (secondsLeft / totalWarningSeconds) * 100);
  const minutes = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const label = `${minutes}:${String(secs).padStart(2, "0")}`;

  return (
    <Modal open={open} closable={true} onCancel={onCloseX} maskClosable={false} footer={null}>
      <Space direction="vertical" size="large" style={{ width: "100%", alignItems: "center", textAlign: "center", padding: "10px 0" }}>
        <Space style={{ width: "100%", justifyContent: "center" }}>
          <ExclamationCircleOutlined style={{ color: "#faad14", fontSize: 24, marginTop: 4 }} />
          <Title level={4} style={{ margin: 0 }}>
            Session Timeout Warning
          </Title>
        </Space>
        <Text style={{ fontSize: 16 }}>
          Your session will expire in <Text strong>{label}</Text>. Please click the "Continue" button to extend your session.
        </Text>
        <Progress
          type="circle"
          percent={percent}
          format={() => (
            <Text strong style={{ fontSize: 20 }}>
              {label}
            </Text>
          )}
          strokeColor={{
            "0%": "#e4002b",
            "100%": "#ff6b8b",
          }}
          strokeWidth={8}
        />
        <Button onClick={onContinue} type="primary" size="large" style={{ minWidth: 120, height: 40, marginTop: 8, fontSize: 17 }}>
          Continue
        </Button>
      </Space>
    </Modal>
  );
};

export default WarningModal;
